export default class HolidayActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_HOLIDAY='GET_HELPER_HOLIDAY';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: HolidayActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: HolidayActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: HolidayActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: HolidayActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: HolidayActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: HolidayActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: HolidayActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: HolidayActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: HolidayActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: HolidayActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: HolidayActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: HolidayActions.GET_HELPER_HOLIDAY,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: HolidayActions.ERROR_SERVER,
      payload: error
    };
  }
}